import React from "react";
export const DeviceInfoItem = (props) => (
    <div className="d-flex align-items-center mb-2">
        <span className="info-label" > {props.label}</span>
        <span className="info-value" title="tooltip">{props.value}</span>
    </div>
);
